import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ExperienceProvider } from "@/context/ExperienceContext";
import { AuthProvider } from "@/context/AuthContext";
import ExperiencePanel from "@/components/ExperiencePanel";
import ChatWidget from "@/components/ChatWidget";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import ProgramDetail from "@/pages/ProgramDetail";
import PercussionPals from "@/pages/PercussionPals";
import PercussionPathways from "@/pages/PercussionPathways";
import DrumTalk from "@/pages/DrumTalk";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Leads from "@/pages/Leads";
import Auth from "@/pages/Auth";

function App() {
  return (
    <div className="App">
      <ExperienceProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/percussion-pals" element={<PercussionPals />} />
              <Route path="/percussion-pathways" element={<PercussionPathways />} />
              <Route path="/drumtalk" element={<DrumTalk />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/leads" element={<Leads />} />
              <Route path="/login" element={<Auth mode="login" />} />
              <Route path="/signup" element={<Auth mode="signup" />} />
              <Route path="/program/:slug" element={<ProgramDetail />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <ExperiencePanel />
            <ChatWidget />
          </BrowserRouter>
          <Toaster position="top-center" />
        </AuthProvider>
      </ExperienceProvider>
    </div>
  );
}

export default App;
